module.exports = __webpack_public_path__ + "static/fonts/Metric-R-semibold.72af32a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metric/Metric-R-semibold.woff2
// module id = ldx4
// module chunks = 28